import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { ManageUserService } from '../services/manage-user-service';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [CommonModule, FormsModule, MatTableModule, MatPaginatorModule, DatePipe, RouterLink, RouterLinkActive],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.css',
})
export class UserListComponent implements OnInit {
  @ViewChild('nameInput') nameInput!: ElementRef;
  displayedColumns: string[] = ['No', 'Name', 'Email', 'MobileNo', 'Role', 'CreatedDateTime', 'Action'];
  users: any[] = [];
  totalCount: number = 0;
  pageSize: number = 10;
  pageIndex: number = 0;
  name: string = '';
  selectFilterBy: string = 'none';
  selectRoleBy: string = 'none';
  selectStatusBy: string = 'none';
  userRoles: string[] = ['Administrator', 'Doctor', 'Member Advocate', 'Nutritionist', 'Fitness Instructor', 'Psychologists'];
  userStatuses: string[] = ['Active', 'InviteSent'];
  timeout: any = null;
  userToDelete: any = null;
  deleting = false;

  constructor(private manageUserService: ManageUserService, private toast: ToastService, private router: Router) {}

  ngOnInit(): void {
    this.getUsers(0);
  }

  getUsers(pageNo: number): void {
    this.manageUserService.getUsersList(this.name, pageNo, this.pageSize, this.selectFilterBy, this.selectRoleBy, this.selectStatusBy).subscribe((response) => {
      this.users = response?.result ?? [];
      this.totalCount = response?.totalCount ?? this.users.length;
    });
  }

  pageChangeEvent(page: PageEvent): void {
    this.pageIndex = page.pageIndex;
    this.getUsers(this.pageIndex);
  }

  filterByName(event: any): void {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.name = event.target.value;
      this.pageIndex = 0;
      this.getUsers(0);
    }, 500);
  }

  onFilterChange(): void {
    this.pageIndex = 0;
    this.getUsers(0);
  }

  resetSearch(): void {
    clearTimeout(this.timeout);
    if (this.nameInput && this.nameInput.nativeElement) {
      this.nameInput.nativeElement.value = '';
    }
    this.name = '';
    this.selectFilterBy = 'none';
    this.selectRoleBy = 'none';
    this.selectStatusBy = 'none';
    this.pageIndex = 0;
    this.getUsers(0);
  }

  updateUser(user: any): void {
    const userId = user.id ?? user.userId;
    if (!userId) {
      this.toast.errorMessage('Unable to update: user id not found');
      return;
    }
    this.router.navigate(['/user/update-user', userId]);
  }

  deleteUser(user: any): void {
    this.userToDelete = user;
  }

  cancelDelete(): void {
    if (this.deleting) {
      return;
    }
    this.userToDelete = null;
  }

  confirmDelete(): void {
    if (!this.userToDelete || this.deleting) {
      return;
    }
    const userId = this.userToDelete.id ?? this.userToDelete.userId;
    if (!userId) {
      this.userToDelete = null;
      this.toast.errorMessage('Unable to delete: user id not found');
      return;
    }
    this.deleting = true;
    this.manageUserService.deleteUser(userId).subscribe({
      next: () => {
        this.deleting = false;
        this.userToDelete = null;
        this.toast.successMessage('User deleted successfully');
        // Step back a page if we just removed the last row on the current page
        if (this.users.length === 1 && this.pageIndex > 0) {
          this.pageIndex--;
        }
        this.getUsers(this.pageIndex);
      },
      error: (err) => {
        this.deleting = false;
        this.userToDelete = null;
        const body = err?.error;
        const message = typeof body === 'string' && body.trim() ? body : body?.message;
        this.toast.errorMessage(message || 'Failed to delete user');
      },
    });
  }
}
